/**
* GENERATED BY RPC GEN - LESS MODIFY BY HAND
* self-service.ts  2024-05-22T11:45:33+08:00
*/
import type { R, RpcService, MethodConfig as M } from 'bt-rpc-base';


const _ = 'Self/';

export class SelfService {

  constructor(readonly r: RpcService) {}
  // web端获取用户id，由于无法操作cookie ; app可以直接解析token
  uid(m?: M): R<string>{
    return this.r.async(_ + 'uid', undefined, m);
  }
}
